export const faqData = [
  {
    id: 1,
    pergunta: '1. A armação é realmente grátis? Tem alguma pegadinha?',
    resposta: 'Transparência total: Na compra das lentes de grau completas conosco, a armação selecionada (da nossa coleção promocional) sai por R$ 0,00. Você paga apenas o valor das lentes e leva os óculos completos!'
  },
  {
    id: 2, 
    pergunta: '2. Como funciona o Exame de Vista Cortesia?',
    resposta: 'É simples: Nós temos parcerias com clínicas e optometristas de excelência. Agendamos seu horário e, ao fechar os óculos na ótica, o custo da consulta é por nossa conta.'
  },
  {
    id: 3,
    pergunta: '3. Já tenho receita de outro médico. Posso aproveitar a promoção?',
    resposta: 'Com certeza! Traga sua receita (dentro da validade). Você compra as lentes com a tecnologia que precisa e, da mesma forma, ganha a armação de presente.'
  },
  {
    id: 4,
    pergunta: '4. Quais tipos de lentes vocês trabalham?',
    resposta: 'Trabalhamos com laboratórios de ponta. Temos Lentes Digitais, Antirreflexo, Filtro Azul (Blue Control), Multifocais e Fotossensíveis (que escurecem no sol). Temos a lente ideal para o seu orçamento.'
  },
  {
    id: 5,
    pergunta: '5. Tenho grau alto. A promoção vale para mim?',
    resposta: 'Sim! Temos opções de lentes de alto índice (mais finas) para graus elevados. Independente do seu grau, na compra do par de lentes, a armação da promoção continua sendo grátis.'
  },
  {
    id: 6,
    pergunta: '6. Quanto tempo demora para os óculos ficarem prontos?',
    resposta: 'Agilidade é nosso forte. Lentes de visão simples podem ficar prontas em até 1-2 dias (sujeito a disponibilidade do laboratório local). Multifocais personalizadas levam de 5-10 dias úteis.'
  },
  {
    id: 7,
    pergunta: '7. E se eu não me adaptar com os óculos?',
    resposta: 'Fique tranquilo. Oferecemos garantia total de adaptação. Caso sinta desconforto ou não se adapte ao grau conferido, fazemos a troca das lentes conforme a política de garantia.'
  },
  {
    id: 8,
    pergunta: '8. Quais são as formas de pagamento?',
    resposta: 'Queremos facilitar sua vida. Parcelamos sua compra em até 10x sem juros no cartão de crédito. Óculos novos com parcelas que cabem no bolso.'
  },
  {
    id: 9,
    pergunta: '9. As armações gratuitas são de qualidade?',
    resposta: 'Sim, são armações modernas, feitas de materiais resistentes como acetato, TR90 e metal. Você escolhe o modelo que mais combina com seu rosto dentre as opções da campanha.'
  },
  {
    id: 10,
    pergunta: '10. Onde ficam as unidades da ótica?',
    resposta: 'Temos diversas lojas estrategicamente localizadas. Ao clicar no botão de agendamento, nossa equipe direcionará você para a unidade mais próxima da sua casa ou trabalho.'
  }
];